import React from 'react';
import {Outlet, useParams} from "react-router-dom";
import ProjectFormProvider from "../../providers/ProjectFormProvider";

const ProjectSetupLayout = () => {

    const {projectId} = useParams();
    //TODO check auth permissions

    return (
        <ProjectFormProvider key={projectId}>
            <Outlet/>
        </ProjectFormProvider>
    );
};

export default ProjectSetupLayout;